import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (18.943 / 24);
  const localHeight = size * (13.208 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 18.943 13.208">
      <path
        d="M440.208,1428.03a.761.761,0,0,1-.54-.224l-5.735-5.735a.763.763,0,1,1,1.079-1.079l5.2,5.195,11.142-11.142a.763.763,0,0,1,1.079,1.079l-11.682,11.682A.761.761,0,0,1,440.208,1428.03Z"
        transform="translate(-433.71 -1414.823)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
